export default "__VITE_ASSET__CqdH_2a9__"